import { useState, useEffect } from "react";
import FilterBar from "../components/FilterBar";
import ListingTable from "../components/ListingTable";
//import { Form, Row, Col } from "react-bootstrap";

function Listings() {
  const today = new Date();
  const oneMonthAgo = new Date(today);
  oneMonthAgo.setMonth(today.getMonth() - 1);

  const formatDate = (d) => d.toISOString().slice(0, 10);

  const defaultValues = {
      dateFrom: formatDate(oneMonthAgo),
      dateTo: formatDate(today),
    };

  const [filters, setFilters] = useState({});

  useEffect(() => {
      setFilters(defaultValues); // ✅ автоматичне завантаження
    }, []);

  return (
    <div className="container-fluid main-container h-100 flex-grow-1">
      <div className="row">
        <div className="col">
          <h1>Listings</h1>
          <FilterBar
            visibleFilters={["search","type","date"]}
            defaultValues={defaultValues}
            onApply={(f) => {
              setFilters(f);
            }}
          />
          <ListingTable filters={filters} />
        </div>
      </div>
    </div>
  );
}

export default Listings;
